require('./product-categories-edit-container.scss')

module.exports = {
  template: require('./product-categories-edit-container.pug')()
  controller: require('./product-categories-edit-container.ctrl')
}
